import { FileSpreadsheet, ShieldCheck } from "lucide-react";

export const Header = () => (
  <header data-testid="app-header" className="mb-10 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 border-b border-slate-200 pb-8 fade-up">
    <div>
      <div className="flex items-center gap-2 text-emerald-700 mb-4">
        <FileSpreadsheet className="w-5 h-5" />
        <span className="text-xs font-semibold tracking-[0.2em] uppercase">PDF → OCR → EXCEL / CSV</span>
      </div>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900 leading-[1.05]">
        Estratti conto<br />
        <span className="text-emerald-700">in Excel e CSV.</span>
      </h1>
      <p className="mt-4 max-w-xl text-sm sm:text-base text-slate-600 leading-relaxed">
        Carica uno o più PDF della banca: leggiamo ogni pagina con l'OCR e ricaviamo data operazione, data valuta, descrizione, addebiti e accrediti.
      </p>
    </div>
    <div data-testid="privacy-badge" className="inline-flex items-center gap-2 self-start sm:self-auto rounded-full border border-slate-200 bg-white px-4 py-2 text-xs font-medium text-slate-600">
      <ShieldCheck className="w-4 h-4 text-emerald-600" />
      Nessun file salvato
    </div>
  </header>
);
